/* Native Home and Featured own their DOM, data, ordering and input. This
   skin changes their appearance only while the Cinema Home route is active. */
/* Jellyfin's body/card alignment and third-party skins include !important
   declarations, and may arrive after this sheet. Keep these overrides confined
   to the active Home page rather than depending on stylesheet load order. */
body.tvl-home { background:#101112 !important; color:#f5f5f2; }
.tvl-home .backgroundContainer { background:#101112 !important; }
.tvl-home #indexPage { background:#101112; color:#f5f5f2; }
.tvl-home .skinHeader:not(.osdHeader) { background:linear-gradient(180deg,#101112ed,#10111299 72%,transparent) !important; }
.tvl-home .skinHeader .headerBackButton { display:none !important; }
/* EmbyTabs.focus() targets the selected tab. Keep Home accessible and
   focusable as an icon instead of hiding the native navigation control. */
.tvl-home .headerTabs .emby-tab-button[data-index="0"],
.tvl-home .headerTabs .emby-tab-button[data-index="0"] .emby-button-foreground { font-size:0; }
.tvl-home .headerTabs .emby-tab-button[data-index="0"] { min-width:2.6rem; min-height:2.6rem; padding:.65rem .85rem; }
.tvl-home .headerTabs .emby-tab-button[data-index="0"]::after { content:''; display:block; width:1.3rem; height:1.3rem; background:currentColor; -webkit-mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M3 10.5 12 3l9 7.5V21h-6v-7H9v7H3z'/%3E%3C/svg%3E") center/contain no-repeat; mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M3 10.5 12 3l9 7.5V21h-6v-7H9v7H3z'/%3E%3C/svg%3E") center/contain no-repeat; }
.tvl-home #homeTab .verticalSection { margin-bottom:2.2em; }
/* Home Screen Sections' per-library rows follow Jellyfin's saved exclusions. */
.tvl-home #homeTab .tvl-home-library-excluded { display:none !important; }
.tvl-home #homeTab .sectionTitle:not(.ec-heading):not(.ec-bootstrap-heading) { color:#f5f5f2; font-weight:600; font-size:1.25em !important; letter-spacing:-.015em; }
.tvl-home #homeTab .sectionTitleTextButton { color:#f5f5f2; }
.tvl-home #homeTab .sectionTitleTextButton:focus { outline:2px solid #d3e7de; outline-offset:3px; border-radius:4px; }
.tvl-home #homeTab .cardBox { background:transparent !important; border-radius:7px !important; box-shadow:none !important; }
.tvl-home #homeTab .visualCardBox { border:0 !important; overflow:visible; }
.tvl-home #homeTab .cardScalable { border-radius:7px !important; }
.tvl-home #homeTab .cardImageContainer { border-radius:7px; background-color:#22302a; }
/* Fit transparent channel logos inside missing-art TV cards without cropping.
   Keep native progress indicators and play targets in place. */
.tvl-home #homeTab .tvl-home-channel-logo { position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;box-sizing:border-box;padding:12%;object-fit:contain;pointer-events:none;border-radius:inherit; }
.tvl-home #homeTab .tvl-home-channel-fallback { background-color:#19241d; }
.tvl-home #homeTab .tvl-home-channel-fallback .cardImageIcon,
.tvl-home #homeTab .tvl-home-channel-fallback .cardDefaultText { visibility:hidden; }
.tvl-home #homeTab .cardText { color:#f5f5f2; padding-left:.7em; padding-right:.7em; }
.tvl-home #homeTab .cardText,
.tvl-home #homeTab .cardText > .textActionButton { text-align:left !important; }
.tvl-home #homeTab .cardText-secondary { color:#b9c4bd; }
.tvl-home #homeTab .cardText:last-child { padding-bottom:.7em; }
/* Both native card builders can wrap titles in an outer footer. Let titles
   and subtitles share the page surface; keep image/progress overlays intact. */
.tvl-home #homeTab .cardFooter,
.tvl-home #homeTab .cardBox > .cardText,
.tvl-home #homeTab .cardFooter > .cardText { background:transparent !important; }
/* Focus follows the thumbnail, including native cards with an outer footer.
   Keep captions outside the ring just like the custom collection cards. */
.tvl-home #homeTab .card { contain:layout style; }
.tvl-home #homeTab .card:focus,
.tvl-home #homeTab .card:focus .cardBox,
.tvl-home #homeTab .cardBox:focus-within { background:transparent; outline:none !important; }
.tvl-home #homeTab .card:focus .cardBox,
.tvl-home #homeTab .cardBox:focus-within,
.tvl-home #homeTab .card:focus .cardScalable,
.tvl-home #homeTab .cardBox:focus-within .cardScalable { border-color:transparent !important; }
.tvl-home #homeTab .card:focus .cardScalable,
.tvl-home #homeTab .cardBox:focus-within .cardScalable { outline:2px solid #f2faf4; outline-offset:3px; }
.tvl-home #homeTab .homeLibraryButton { background:#22302a; border:2px solid #ffffff20; border-radius:7px; color:#f5f5f2; box-shadow:none; }
.tvl-home #homeTab .homeLibraryButton:hover { background:#29382f; }
.tvl-home #homeTab .homeLibraryButton:focus { outline:2px solid #f2faf4; outline-offset:3px; background:#2c3731; }

/* Featured keeps its own height, layout, fades, controls and personalisation.
   Scope palette tokens to its Home instance rather than its global theme. */
.tvl-home #homeTab .ec-root {
  --ec-theme-primary:#f6f6f3;
  --ec-theme-primary-dark:#dfe4e0;
  --ec-theme-primary-contrast:#101112;
  --ec-theme-secondary:#d3e7de;
  --ec-theme-background:#101112;
  --ec-theme-paper:#19241d;
  --ec-theme-text-primary:#f5f5f2;
  --ec-theme-text-secondary:#b9c4bd;
  --ec-theme-contained:#26342ce6;
  --ec-theme-contained-hover:#35453a;
  --ec-button-radius:7px;
  --ec-on-media-color:#f5f5f2;
  --ec-media-shade:linear-gradient(90deg,rgb(16 17 18 / var(--ec-gradient-strength)) 0%,rgb(16 17 18 / calc(var(--ec-gradient-strength) * .74)) 30%,rgb(16 17 18 / calc(var(--ec-gradient-strength) * .16)) 66%,rgb(16 17 18 / calc(var(--ec-gradient-strength) * .42)) 100%),linear-gradient(0deg,rgb(16 17 18 / calc(var(--ec-gradient-strength) * .74)),transparent 45%);
  font-family:'Segoe UI','Helvetica Neue',Arial,sans-serif;
}
.tvl-home #homeTab .ec-root .ec-title { font-family:'Arial Narrow','Helvetica Neue',Arial,sans-serif; font-weight:900; letter-spacing:-.025em; text-transform:uppercase; }
.tvl-home #homeTab .ec-root .ec-overview { color:#b9c4bd; }
.tvl-home #homeTab .ec-root .ec-button { background:var(--ec-theme-primary) !important; color:var(--ec-theme-primary-contrast) !important; border-radius:var(--ec-button-radius); }
.tvl-home #homeTab .ec-root .ec-button:hover,
.tvl-home #homeTab .ec-root .ec-button:focus { background:var(--ec-theme-primary-dark) !important; }
.tvl-home #homeTab .ec-root .ec-button:focus { outline:2px solid var(--ec-theme-secondary); outline-offset:3px; }
.tvl-home #homeTab .ec-root .ec-button-secondary { background:var(--ec-theme-contained) !important; color:var(--ec-theme-text-primary) !important; }
.tvl-home #homeTab .ec-root .ec-button-secondary:hover,
.tvl-home #homeTab .ec-root .ec-button-secondary:focus { background:var(--ec-theme-contained-hover) !important; }
